
import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from "components/search_sidebar/filter_number_pair";
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterCheckboxGroup from "components/search_sidebar/filter_checkbox_group";

import { Checkbox } from 'react-bootstrap';

export default class IndustrialFilters extends React.Component {

  static propTypes = {
    availableRailProviders: PropTypes.array.isRequired,
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    industrialFilter: PropTypes.object.isRequired,
    lotBorderTypes: PropTypes.array.isRequired,
    lotStabilizations: PropTypes.array.isRequired,
    servedRailProviders: PropTypes.array.isRequired,
    onIndustrialFilterChange: PropTypes.func.isRequired
  };

  handleChange = (e, name, checkbox = false) => {
    this.props.onIndustrialFilterChange(e, name, checkbox);
  }

  render() {
    return (
      <React.Fragment>
        <div className="building-information">
          {this.renderCraneFilters()}
        </div>
        <div className="building-information">
          {this.renderYardFilters()}
          {this.renderRailFilters()}
          {this.renderOtherFilters()}
        </div>
      </React.Fragment>
    );
  }

  renderOtherFilters() {
    const { industrialFilter, filterLabelMappings } = this.props;

    return (
      <React.Fragment>
        <h4 className="hidden-xs hidden-sm bold mb-0 mt-5">Other</h4>
        <hr className="hidden-xs hidden-sm mt-2 mb-2"/>
        <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
          <div className="col-md-12 pl-0">
            <div className="filter-checkbox">
              <Checkbox
                checked={industrialFilter.driveThroughAccess}
                name=""
                onChange={e => this.handleChange(e, "driveThroughAccess", true)}
              >
                {filterLabelMappings["driveThroughAccess"]}
              </Checkbox>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderRailFilters() {
    const {
      availableRailProviders,
      servedRailProviders,
      filterLabelMappings,
      industrialFilter
    } = this.props;

    return (
      <React.Fragment>
        <h4 className="hidden-xs hidden-sm bold mb-0 mt-5">Rail</h4>
        <hr className="hidden-xs hidden-sm mt-2 mb-2"/>
        <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
          <div className="col-md-6 pl-0">
            <FilterCheckboxGroup
              label={filterLabelMappings['servedRailProvider']}
              options={servedRailProviders}
              selected={[industrialFilter.servedRailProvider]}
              onChange={e => this.handleChange(e, "servedRailProvider")}
            />
          </div>
          <div className="col-md-6 pl-0">
            <FilterCheckboxGroup
              label={filterLabelMappings['availableRailProvider']}
              options={availableRailProviders}
              selected={[industrialFilter.availableRailProvider]}
              onChange={e => this.handleChange(e, "availableRailProvider")}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderYardFilters() {
    const {
      filterKeyMappings,
      filterLabelMappings,
      lotBorderTypes,
      lotStabilizations,
      industrialFilter
    } = this.props;

    return (
      <React.Fragment>
        <h4 className="hidden-xs hidden-sm bold mb-0 mt-2">Yard</h4>
        <hr className="hidden-xs hidden-sm mt-2 mb-2"/>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['acresStabilized']}
              name="acresStabilized"
              valueKeys={filterKeyMappings['acresStabilized']}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
          <div className="col-md-12 pl-0">
            <div className="filter-checkbox">
              <FilterCheckboxGroup
                inline
                label={filterLabelMappings['lotStabilization']}
                options={lotStabilizations}
                selected={[industrialFilter.lotStabilization]}
                onChange={e => this.handleChange(e, "lotStabilization")}
              />
            </div>
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
          <div className="col-md-12 pl-0">
            <div className="filter-checkbox">
              <FilterCheckboxGroup
                inline
                label={filterLabelMappings['lotBorderType']}
                options={lotBorderTypes}
                selected={[industrialFilter.lotBorderType]}
                onChange={e => this.handleChange(e, "lotBorderType")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderCraneFilters() {
    const {
      filterKeyMappings,
      filterLabelMappings,
      industrialFilter
    } = this.props;

    return (
      <React.Fragment>
        <h4 className="hidden-xs hidden-sm bold mb-0 mt-2">Crane</h4>
        <hr className="hidden-xs hidden-sm mt-2 mb-2"/>
        <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
          <div className="col-md-12 pl-0 mt-2 mb-r">
            <div className="filter-checkbox">
              <Checkbox
                checked={industrialFilter.served}
                name=""
                onChange={e => this.handleChange(e, "served", true)}
              >
                {filterLabelMappings["served"]}
              </Checkbox>
            </div>
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['numBridgeCranes']}
              name="numBridgeCranes"
              valueKeys={filterKeyMappings['numBridgeCranes']}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['bridgeCraneSpan']}
              name="bridgeCraneSpan"
              valueKeys={filterKeyMappings['bridgeCraneSpan']}
              onChange={this.handleChange}
            />
          </div>
          <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
            <FilterSelect disabled placeholder="Feet"/>
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['numJibCranes']}
              name="numJibCranes"
              valueKeys={filterKeyMappings['numJibCranes']}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['jibCraneSpan']}
              name="jibCraneSpan"
              valueKeys={filterKeyMappings['jibCraneSpan']}
              onChange={this.handleChange}
            />
          </div>
          <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
            <FilterSelect disabled placeholder="Feet"/>
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
          <div className="col-md-12 pl-0 mb-3">
            <div className="filter-checkbox">
              <Checkbox
                checked={industrialFilter.ready}
                name=""
                onChange={e => this.handleChange(e, "ready", true)}
              >
                {filterLabelMappings["ready"]}
              </Checkbox>
            </div>
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['readyCapacity']}
              name="readyCapacity"
              valueKeys={filterKeyMappings['readyCapacity']}
              onChange={this.handleChange}
            />
          </div>
          <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
            <FilterSelect disabled placeholder="Tons"/>
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="pl-0 col-md-9">
            <FilterNumberPair
              filter={industrialFilter}
              label={filterLabelMappings['readySpan']}
              name="readySpan"
              valueKeys={filterKeyMappings['readySpan']}
              onChange={this.handleChange}
            />
          </div>
          <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
            <FilterSelect disabled placeholder="Feet"/>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
